import react from "react";
import Grid from "@mui/material/Grid";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import img from "../../assets/imgs/Session-img.png";
import Buttons from "../Button/Button";
import CourseCard from "./CourseCard";
import EmptyCard from "../../components/EmptyCard/EmptyCard";

function Upcoming(props) {
  const { courses, setUpdateCart, enrollNowHandler } = props;

  return (
    <div>
      <Grid container spacing={3}>
        {courses ? (
          <CourseCard
            courses={courses}
            setUpdateCart={setUpdateCart}
            cardBtn="show"
            enrollNowHandler={enrollNowHandler}
          />
        ) : (
          <Grid item xs={12} sm={12} md={12}>
            <EmptyCard
              title="You will find upcoming courses here"
              Description="Please stay tuned for new courses"
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default Upcoming;
